import React, { useState } from 'react'
// import { PDFViewer } from '@react-pdf/renderer';
import { PDFViewer, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer'

import RightSidebar from '../RightSidebar'
import './styles.less'

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4',
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
})

const MyDocument = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* {data} */}
      <View style={styles.section}>
        <Text> Rendering..
        </Text>
      </View>
      {/* <View style={styles.section}>
        <Text>Section #2</Text>
      </View> */}
    </Page>
  </Document>
)

export default function RightSidebarPDF({ children, data, ...props }) {
  const [isOpenSidebar, setIsOpenSidebar] = useState(false)
  return (
    <RightSidebar>
      <PDFViewer>
        <MyDocument data={data} />
      </PDFViewer>
    </RightSidebar>
  )
}
